import { Box, LinearProgress, Typography } from '@mui/material';

/** Local heuristic, no dependency: one point per signal (length ≥8, length
 * ≥12, mixed case + digit, a special character), capped at 4. Good enough
 * to nudge users toward stronger passwords without pulling in a scoring
 * library (this repo consistently prefers a small local heuristic over a
 * new dependency where one suffices). */
const scorePassword = (password: string): number => {
  if (!password) return 0;
  let score = 0;
  if (password.length >= 8) score += 1;
  if (password.length >= 12) score += 1;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password) && /[0-9]/.test(password)) score += 1;
  if (/[^a-zA-Z0-9]/.test(password)) score += 1;
  return Math.min(score, 4);
};

const LABELS = ['Weak', 'Weak', 'Fair', 'Good', 'Strong'];
const COLORS = ['error.main', 'error.main', 'warning.main', 'info.main', 'success.main'];

export const PasswordStrengthMeter = ({ password }: { password: string }) => {
  if (!password) return null;
  const score = scorePassword(password);

  return (
    <Box>
      <LinearProgress
        variant="determinate"
        value={(score / 4) * 100}
        sx={{
          height: 6,
          borderRadius: 3,
          bgcolor: 'action.hover',
          '& .MuiLinearProgress-bar': { bgcolor: COLORS[score], borderRadius: 3 },
        }}
      />
      <Typography variant="caption" sx={{ color: COLORS[score] }}>
        {LABELS[score]}
      </Typography>
    </Box>
  );
};
